import { z } from 'zod'

const addressSchema = z.union([
  z
    .string()
    .regex(/^0x[0-9a-fA-F]{40}$/)
    .transform((v) => v.toLowerCase()),
  z.string(),
])

export const assetsBurnedSchema = z.object({
  assetId: z.string().transform((v) => BigInt(v.replaceAll(',', ''))),
  owner: addressSchema,
  balance: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
})

export const assetsIssuedSchema = z.object({
  assetId: z.string().transform((v) => BigInt(v.replaceAll(',', ''))),
  owner: addressSchema,
  amount: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
})

export const assetsTransferredSchema = z.object({
  assetId: z.string().transform((v) => BigInt(v.replaceAll(',', ''))),
  from: addressSchema,
  to: addressSchema,
  amount: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
})

export const balancesBurnedSchema = z.object({
  who: addressSchema,
  amount: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
})

export const balancesDepositSchema = z.object({
  who: addressSchema,
  amount: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
})

export const balancesMintedSchema = z.object({
  who: addressSchema,
  amount: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
})

export const balancesTransferSchema = z.object({
  from: addressSchema,
  to: addressSchema,
  amount: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
})

export const balancesWithdrawSchema = z.object({
  who: addressSchema,
  amount: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
})

export const tokensDepositedSchema = z.object({
  currencyId: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
  who: addressSchema,
  amount: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
})

export const tokensTransferSchema = z.object({
  currencyId: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
  from: addressSchema,
  to: addressSchema,
  amount: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
})

export const tokensWithdrawnSchema = z.object({
  currencyId: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
  who: addressSchema,
  amount: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
})

export const transactionPaymentTransactionFeePaidSchema = z.object({
  who: addressSchema,
  actualFee: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
  tip: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
})

/** dappStaking.Reward event の data schema。 */
export const dappStakingRewardSchema = z.object({
  account: addressSchema,
  amount: z
    .string()
    .regex(/^[\d\,]+$/)
    .transform((v) => BigInt(v.replaceAll(',', ''))),
})

/** xcmPallet.FeesPaid event の fee schema。 */
export const xcmPalletFeesPaidSchema = z.object({
  paying: z.object({
    interior: z.object({
      X1: z.tuple([
        z.object({
          AccountId32: z.object({
            id: z.string().regex(/^0x[\da-fA-F]{64}$/),
          }),
        }),
      ]),
    }),
  }),
  fees: z.array(
    z.object({
      id: z.object({
        parents: z
          .string()
          .regex(/^[\d\,]+$/)
          .transform((v) => BigInt(v.replaceAll(',', ''))),
        interior: z.unknown(),
      }),
      fun: z.object({
        Fungible: z
          .string()
          .regex(/^[\d\,]+$/)
          .transform((v) => BigInt(v.replaceAll(',', ''))),
      }),
    }),
  ),
})
